import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const SIZE = {
  SMALL: 'SMALL',
  NORMAL: 'NORMAL',
  BIG: 'BIG',
};

const sizes = {
  SMALL: 16,
  NORMAL: 24,
  BIG: 32,
};

export const Icon = styled.img`
  display: block;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;

  ${({ size }) => {
    return css`
      ${Icon} {
        width: ${sizes[size]}px;
      }
    `;
  }}
`;
